import { createFileRoute } from "@tanstack/react-router";
import OrganizationSettings from "@/pages/OrganizationSettings";

export const Route = createFileRoute("/_app/settings/organizations-agent")({
  component: OrganizationSettings,
});
